import React from 'react';
import { bind } from "decko";
import { hashHistory } from "react-router";
import PropTypes from "prop-types";

import LiveStream from "./LiveStream";
import StreamPicker from "./StreamPicker";
import HomeBtn from "./HomeBtn";
import GenericBlackBtn from "./GenericBlackBtn";

import {getServer, listLoggedInServers} from "./include/Server";
import HotkeyHandler from "./include/HotkeyHandler";
import Config, {setConfigVariable} from "./include/Config";

const ignored_content_sources = ["antourage", "clubs"];

export default class Level1App extends React.Component {
    constructor (props) {
        super(props);

        this.state = {
            errorMsg: "",
            focus: null,
            streams: [],
            tiles: [ null, null, null, null ],
            displayQuad: Config.displayQuad,
        };

        this.globalHotkeyHandler = new HotkeyHandler(true);
        this.hotkeyHandler = new HotkeyHandler(Config.displayQuad);
        this.windowHotkeyHandlers = [
            new HotkeyHandler(Config.displayQuad),
            new HotkeyHandler(false),
            new HotkeyHandler(false),
            new HotkeyHandler(false),
            new HotkeyHandler(!Config.displayQuad), // Fullscreen hotkey handler
        ];
    }

    componentDidMount () {
        this.loadLivePlaylist();
        this.updateInterval = setInterval(this.loadLivePlaylist, 5000);

        this.hotkeyHandler.subscribe({
            "1": () => this.changeFocus(0),
            "2": () => this.changeFocus(1),
            "3": () => this.changeFocus(2),
            "4": () => this.changeFocus(3),
        }, this);

        // const query = "localhost_4410,,localhost_111410,localhost_4410";
        const query = hashHistory.getCurrentLocation().query.streams;
        console.log("Starting with stream query:", query);
        if (query) this.loadFromQueryStreams(query);
    }

    componentWillUnmount () {
        clearInterval(this.updateInterval);

        // Clear the hotkey handlers
        this.globalHotkeyHandler.destroy();
        this.hotkeyHandler.destroy();
        this.windowHotkeyHandlers.forEach((h) => h.destroy());
    }

    loadFromQueryStreams (query) {
        const items = query.split(",");
        for (let i=0; i<(Math.min(items.length, 4)); ++i) {
            try {
                const [serverName, id] = items[i].split("_");
                if (serverName === undefined || id === undefined) continue;
                const server = getServer(serverName);
                server.get("/asset/" + id, (stream) => {
                    stream.key = server.name + "_" + stream.id;
                    stream.server = server;
                    this.startStream(i, stream);
                });
            } catch (e) {
                console.error("Caught exception trying to load streams from query params", e);
            }
        }
    }

    updateQueryStreams (idx, stream) {
        const location = hashHistory.getCurrentLocation();
        let query = location.query.streams;
        if (!query) query = "";
        let streams = query.split(",");
        if (stream === null) delete streams[idx];
        else streams[idx] = stream.key;
        location.query.streams = streams.join(",");
        hashHistory.replace(location);
    }

    getChildContext () {
        return {
            globalHotkeyHandler: this.globalHotkeyHandler
        }
    }

    @bind
    changeFocus (idx) {
        this.windowHotkeyHandlers.forEach((h,i) => h.setEnabled(idx === i));
        this.setState({focus: idx});
    }

    @bind
    loadLivePlaylist () {

        // If all windows are actively playing a stream - skip update
        if (this.state.displayQuad) {
            if (!(this.state.tiles.some((t) => t === null))) { return; }
        } else if (this.state.tiles[0] !== null) { return; }

        let servers = listLoggedInServers();
        let newStreams = [];
        let successCnt = 0;

        const handleStreams = (streams, server) => {

            streams.forEach((stream) => {
                stream.key = server.name + "_" + stream.id;
                stream.server = server;
            });

            newStreams = newStreams.concat(streams);

            if (++successCnt === servers.length) {
                // Ensure other content that happens to be streamed live doesnt show up
                newStreams = newStreams.filter(
                    s => ignored_content_sources.indexOf(s.content_source) === -1
                );
                // Set deterministic ordering to avoid flickering - show oldest stream first
                newStreams = newStreams.sort((a,b) => b.duration_ms - a.duration_ms);
                this.setState({
                    errorMsg: "",
                    streams: newStreams
                });
            }
        };

        servers.forEach((server) => (
            server.get("/asset/live", (data) => (
                handleStreams(data.assets, server)
            ), (error) => {
                console.error("Problem fetching live streams from the server " + error);
                this.setState({
                    errorMsg: "Error fetching streams from the server (" + server.name + "): " + error
                });
            })
        ));
    }

    @bind
    toggleQuadView () {
        let displayQuad = !this.state.displayQuad;
        if (displayQuad) {
            this.changeFocus(0);
        } else {
            this.changeFocus(4);
        }
        this.hotkeyHandler.setEnabled(displayQuad);
        setConfigVariable("displayQuad", displayQuad);
        this.setState({displayQuad: displayQuad});
    }

    startStream (idx, stream) {
        console.log("Starting stream", stream, "in tile", idx);

        let tiles = this.state.tiles.slice();
        tiles[idx] = stream;

        this.updateQueryStreams(idx, stream);
        this.setState({
            tiles: tiles
        });
    }

    closeStream (idx) {
        console.log("Closing stream", idx);

        let tiles = this.state.tiles.slice();
        tiles[idx] = null;

        this.updateQueryStreams(idx, null);
        this.setState({
            tiles: tiles
        });
    }

    pickComponentToDisplay (idx) {
        let component;
        let stream = this.state.tiles[idx];
        let hotkeyIdx = this.state.displayQuad ? idx : 4;
        if (stream === null) {
            component = (
                <StreamPicker
                    hotkeyHandler={this.windowHotkeyHandlers[hotkeyIdx]}
                    streams={this.state.streams}
                    errorMsg={this.state.errorMsg}
                    onStartStream={(stream) => this.startStream(idx, stream)} />
            );
        } else {
            component = (
                <LiveStream
                    stream={stream}
                    possessionTracking={Config.possessionTracking}
                    quadStreamIdx={hotkeyIdx}
                    quadLayout={this.state.displayQuad}
                    displayTimeline={Config.displayTimeline}
                    hotkeyHandler={this.windowHotkeyHandlers[hotkeyIdx]}
                    onCloseStream={() => this.closeStream(idx)} />
            );
        }

        if (!this.state.displayQuad) return component;

        let style = {
            outline: "black solid 4px"
        };
        if (!this.state.displayQuad || this.state.focus === idx) {
            style.outline = "yellow solid 4px";
        }

        return (
            <div style={style} onClick={() => this.changeFocus(idx)}>
                {component}
            </div>
        );
    }

    renderSingle () {
        return (
            <div className="col-xs-12" style={{marginTop:"10px"}}>
                {this.pickComponentToDisplay(0)}
            </div>
        );
    }

    renderQuad () {
        return (
            <div>
                <div className="col-xs-12" style={{minHeight: "50vh"}}>
                    <div className="col-xs-6" style={{marginTop:"10px", paddingLeft:"10px", paddingRight:"5px"}}>
                        {this.pickComponentToDisplay(0)}
                    </div>
                    <div className="col-xs-6" style={{marginTop:"10px", paddingLeft:"5px", paddingRight:"10px"}}>
                        {this.pickComponentToDisplay(1)}
                    </div>
                </div>
                <div className="col-xs-12">
                    <div className="col-xs-6" style={{marginTop:"5px", paddingLeft:"10px", paddingRight:"5px"}}>
                        {this.pickComponentToDisplay(2)}
                    </div>
                    <div className="col-xs-6" style={{marginTop:"5px", paddingLeft:"5px", paddingRight:"10px"}}>
                        {this.pickComponentToDisplay(3)}
                    </div>
                </div>
            </div>
        );
    }

    render () {

        let grid;
        if (this.state.displayQuad) {
            grid = this.renderQuad();
        } else {
            grid = this.renderSingle();
        }

        return (
            <div className="row" style={{minHeight: "100vh", backgroundColor: "black"}}>
                { grid }
                <HomeBtn style={{position: "absolute", left: "2px", top: "2px", zIndex: "10"}} />
                <GenericBlackBtn
                    style={{position: "absolute", left: "44px", top: "2px", zIndex: "10"}}
                    onClick={this.toggleQuadView}>
                    <span className="glyphicon glyphicon-th-large" />
                </GenericBlackBtn>
            </div>
        );
    }
}

Level1App.childContextTypes = {
    globalHotkeyHandler: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/js/Level1App.js